import { useSyncExternalStore } from 'react';
import { getAuthState, subscribeAuthState, type AuthState } from './auth-store';

/**
 * React hook exposing the memory-only auth store（ADR-0004 §4.2 #3）。
 * 用 `useSyncExternalStore` 兼容 React 19 的 concurrent rendering。
 */
export function useAuth(): AuthState {
  return useSyncExternalStore(subscribeAuthState, getAuthState, getAuthState);
}
